import React from "react";
import styles from "../../../assets/css/modules/shared/summary-row-cells/summary-detail-with-status-panel.css";
import StatusPanel from "../notices/StatusPanel";

const SummaryCellWithStatusPanel = ({
  topLabel,
  bottomLabel,
  hideStatusPanel,
  statusPanelText,
  statusColour
}) => {
  return (
    <div className={styles.summaryDetailWithStatusPanel}>
      <h3>{topLabel}</h3>
      <p>{bottomLabel}</p>
      {hideStatusPanel ? null : (
        <StatusPanel text={statusPanelText} statusColour={statusColour} />
      )}
    </div>
  );
};

export default SummaryCellWithStatusPanel;
